import cn from "classnames"

import { NotificationInstance } from "@/atoms"

import type { OpenArguments, TaskState } from "./TaskProvider.types"

export const openNotification =
  (key: string, notification: NotificationInstance) =>
  (value: OpenArguments) => {
    const { className, ...rest } = value

    notification.open({
      key,
      placement: "bottomRight",
      className: cn("task-notification-task-provider", className),
      ...rest
    })
  }

export const closeNotification =
  (key: string, notification: NotificationInstance) => () => {
    notification.destroy(key)
  }

export const updateState =
  (
    id: string,
    setState: React.Dispatch<
      React.SetStateAction<Record<string, TaskState<unknown, unknown>>>
    >
  ) =>
  (newState: TaskState<unknown, unknown>) =>
    setState((prevState) => ({
      ...prevState,
      [id]: newState
    }))
